module.exports = __webpack_public_path__ + "img/jiu.61922506.jpg";